import React, { useEffect } from "react";
import "./App.css";
import magic from "./magic";
import LightsPanel from "./LightsPanel";
import BatteryPanel from "./BatteryPanel";
import HeaterPanel from "./HeaterPanel";
import HotWaterPanel from "./HotWaterPanel";
import HomePanel from "./HomePanel";
import { FaHome, FaLightbulb, FaBatteryHalf, FaFire, FaTint, FaCheck, FaSpinner } from "react-icons/fa";

/// <reference types="web-bluetooth" />

function App() {
	const [commandError,setCommandError]=React.useState(null);
	const [bleStatus, setBleStatus] = React.useState("disconnected");
	const [activePanel, setActivePanel] = React.useState("home");
	const [commandProgress,setCommandProgress]=React.useState("idle");

    useEffect(()=>{
      const onError=message=>setCommandError(message);
      magic.bleEventDispatcher.on('command-error',onError);
      return ()=>magic.bleEventDispatcher.removeListener('command-error',onError);
    },[]);
	useEffect(()=>{
		const onProgress=state=>setCommandProgress(state);
		magic.bleEventDispatcher.on('command-progress',onProgress);
		return ()=>magic.bleEventDispatcher.removeListener('command-progress',onProgress);
	},[]);
	useEffect(() => {
		const onStatus = (status) => {
			setBleStatus(status);
			if (status !== "connected") {
				setActivePanel("home");
			}
		};
		magic.bleEventDispatcher.on("status", onStatus);
		return () => {
			magic.bleEventDispatcher.removeListener("status", onStatus);
		};
	}, []);

	return (
		<div className="App">
			<header className="App-header">
				<div className="content">
                    {commandError && <div role="alert">{commandError} <button onClick={()=>setCommandError(null)}>Dismiss</button></div>}
					<fieldset className="command-surface" disabled={commandProgress === 'pending'} aria-busy={commandProgress === 'pending'}>
					<HomePanel
						visible={activePanel === "home"}
						bleStatus={bleStatus}
						onConnect={magic.connectBLE}
						onConnectInternet={magic.connectInternet}
						onForgetInternet={magic.forgetInternetAccess}
						onDisconnect={magic.disconnectBLE}
					/>

					{bleStatus === "connected" && (
						<>
							<LightsPanel visible={activePanel === "lights"} />
							<BatteryPanel visible={activePanel === "battery"} />
							<HeaterPanel visible={activePanel === "heater"} />
							<HotWaterPanel visible={activePanel === "hotwater"} />
						</>
					)}
					</fieldset>
					{commandProgress !== 'idle' && <div className={`command-progress ${commandProgress}`} role="status" aria-live="polite">
						{commandProgress === 'pending' ? <FaSpinner /> : <FaCheck />}
						<span>{commandProgress === 'pending' ? 'Sending' : 'Saved'}</span>
					</div>}
				</div>
			</header>

			{bleStatus === "connected" && (
				<nav className="bottom-nav" role="navigation" aria-label="Main">
					<button
						aria-label="Home"
						className={activePanel === "home" ? "active" : ""}
						onClick={() => setActivePanel("home")}
						title="Home"
					>
						<FaHome />
					</button>
					<button
						aria-label="Lights"
						className={activePanel === "lights" ? "active" : ""}
						onClick={() => setActivePanel("lights")}
						title="Lights"
					>
						<FaLightbulb />
					</button>
					<button
						aria-label="Battery"
						className={activePanel === "battery" ? "active" : ""}
						onClick={() => setActivePanel("battery")}
						title="Battery"
					>
						<FaBatteryHalf />
					</button>
					<button
						aria-label="Heater"
						className={activePanel === "heater" ? "active" : ""}
						onClick={() => setActivePanel("heater")}
						title="Heater"
					>
						<FaFire />
					</button>
					<button
						aria-label="Hot Water"
						className={activePanel === "hotwater" ? "active" : ""}
						onClick={() => setActivePanel("hotwater")}
						title="Hot Water"
					>
						<FaTint />
					</button>
				</nav>
			)}
		</div>
	);
}

export default App;

